import React from "react";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import FormDropdownField from "src/components/Form/FormDropdownField/FormDropdownField";
import NumberField from "src/components/Form/NumberFormatFieldV2/NumberFormatFieldV2";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import * as S from "src/constants/StringConstants";
import { addDefaultOption } from "src/util/utils.defaultValues";

const RidersForm = ({ productDetails }) => {
  return (
    <Col sm="3">
      <Row>
        <Col sm="10" className="app-form-header">
          <h4 className="form-title">{S.APP_PRODUCT_RIDERS_TITLE}</h4>
        </Col>
      </Row>

      <Row className="app-checkbox-container">
        <Row>
          <Col sm="12">
            <CheckboxField name="basicResidual" label={S.APP_PRODUCT_FIELD_BASIC_RESIDUAL} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="enhancedResidual" label={S.APP_PRODUCT_FIELD_ENHANCED_RESIDUAL} />
          </Col>
        </Row>

        <Row className="app-checkbox-form-row">
          <Col sm="12" className="app-form-checkbox-container">
            <CheckboxField name="enhancedPlus" label={S.APP_PRODUCT_FIELD_ENHANCED_PLUS} />
          </Col>
        </Row>

        <Row className="app-checkbox-form-row">
          <Col>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="residualAndRecovery" label={S.APP_PRODUCT_FIELD_RESIDUAL_AND_RECOVERY} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="extendedPartial" label={S.APP_PRODUCT_FIELD_EXTENDED_PARTIAL} />
          </Col>
        </Row>

        <Row className="app-checkbox-form-row">
          <Col sm="12" className="app-form-checkbox-container">
            <CheckboxField name="noncan" label={S.APP_PRODUCT_FIELD_NON_CAN} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="guaranteeRenewable" label={S.APP_PRODUCT_FIELD_GUARANTEE_RENEWABLE} />
          </Col>
        </Row>

        <Row>
          <Col>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="ownOcc" label={S.APP_PRODUCT_FIELD_OWN_OCC} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="transOcc" label={S.APP_PRODUCT_FIELD_TRANS_OCC} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="modifiedOwnOcc" label={S.APP_PRODUCT_FIELD_MODIFIED_OWN_OCC} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="anyOcc" label={S.APP_PRODUCT_FIELD_ANY_OCC} />
          </Col>
        </Row>

        <Row>
          <Col>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col sm="12" className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="cola" label={S.APP_PRODUCT_FIELD_COLA} />
            </Col>
            <Col sm="4">
              <TextField name="colaAmount" />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col sm="12" className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="cat" label={S.APP_PRODUCT_FIELD_CAT} />
            </Col>
            <Col sm="4">
              <NumberField name="catAmount" prefix="$" thousandSeparator={true} decimalScale={2} />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="aib" label={S.APP_PRODUCT_FIELD_AIB} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="capitalSumBenefit" label={S.APP_PRODUCT_FIELD_CSB} />
          </Col>
        </Row>

        <Row>
          <Col sm="12">
            <CheckboxField name="bir" label={S.APP_PRODUCT_FIELD_BIR} />
          </Col>
        </Row>

        <Row>
          <Col sm="12" className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="fio" label={S.APP_PRODUCT_FIELD_FIO} />
            </Col>
            <Col sm="4">
              <NumberField name="fioAmount" prefix="$" thousandSeparator={true} decimalScale={2} />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="blp" label={S.APP_PRODUCT_FIELD_BLP} />
            </Col>
            <Col sm="4">
              <NumberField name="blpAmount" prefix="$" thousandSeparator={true} decimalScale={2} />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="studentLoan" label={S.APP_PRODUCT_FIELD_STUDENT_LOAN} />
            </Col>
            <Col sm="4">
              <NumberField name="studentAmount" prefix="$" thousandSeparator={true} decimalScale={2} />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col className="app-form-checkbox-label-container__text-field">
            <Col sm="6"></Col>
            <Col sm="4">
              <FormDropdownField
                name="studentLoanDurationTypeID"
                label={""}
                options={addDefaultOption("", productDetails?.selectStudentLoanDurationTypeList)}
              />
            </Col>
          </Col>
        </Row>

        <Row>
          <Col sm="12" className="app-form-checkbox-label-container__text-field">
            <Col sm="6">
              <CheckboxField name="other" label={S.APP_PRODUCT_FIELD_OTHER} />
            </Col>
            <Col sm="4">
              <NumberField name="otherAmount" prefix="$" thousandSeparator={true} decimalScale={2} />
            </Col>
          </Col>
        </Row>
      </Row>
      <Row className="mt-3">
        <Col sm="10" className="app-form-header">
          <h4 className="form-title">{S.APP_PRODUCT_FIELD_NOTES}</h4>
        </Col>
      </Row>
      <Row>
        <TextField name="notes" multiline />
      </Row>
    </Col>
  );
};

export default RidersForm;
